import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageSubtitleService {
  private subtitle$ = new BehaviorSubject<string>('');

  /**
   * Sets the page subtitle
   */
  setSubtitle(subtitle: string): void {
    this.subtitle$.next(subtitle);
  }

  /**
   * Gets the current page subtitle as an observable
   */
  getSubtitle(): Observable<string> {
    return this.subtitle$.asObservable();
  }

  /**
   * Clears the subtitle
   */
  clearSubtitle(): void {
    this.subtitle$.next('');
  }
}
